import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class AlarmManagement {
  // 导出测点实时数据
  static async exportRealTime(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MeasuringPoint/export-runtime-value', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导出测点历史数据
  static async exportHistory(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MeasuringPoint/export-interval-runtime-value', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取机组数据
  static async getGroupData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MeasuringPoint/plant-unit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取阈值/开关量报警列表
  static async getGroupAlarmList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/rota_alarm_record/alarms/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取专业
  static async getProfession() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/profession')
    )
    return Callback(err, res)
  }
  // 获取阈值/开关量历史报警列表
  static async getHistoryGroupAlarmList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/alarm_record/history_alarms/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取当前值班信息
  static async getCurrentDuty(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/rota/rota_template/get_rota_bytime?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取基础信息
  static async getAlarmDetailData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/alarm_record/alarm_detail/${payload.point_id}/${payload.rowId}/${payload.category}`
      )
    )
    return Callback(err, res)
  }
  // 重置报警时间
  static async resetAlarmTime(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/alarm_record/reset/${payload.config_id}`)
    )
    return Callback(err, res)
  }
  // 获取历史报警记录列表
  static async getHistoryAlarm(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/alarm_record/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取报警配置
  static async getThresholdConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/threshold_config/threshold_config/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导出历史报警记录
  static async exportHistoryAlarm(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/alarm_record/export/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取实时报警统计
  static async getActualTimeAlarm(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/rota_alarm_record/alarm_statistic/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取监视清单列表
  static async getGuardList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/threshold_config/threshold_config/thresholdconfig_point/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取开关量报警清单列表
  static async getSwitchAlarmList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/alarm_record/history_alarms_list/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 从大数据获取实时数据
  static async getRealTimeCurve(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/WizIot/get-tags-runtime-value', payload)
    )
    return Callback(err, res)
  }
  // 获取统计数据
  static async getHistoryCurve(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/WizIot/get-tags-pag-value', payload)
    )
    return Callback(err, res)
  }
  // 获取曲线数据
  static async getTrendLine(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/WizIot/get-tags-runtime-value', payload)
    )
    return Callback(err, res)
  }
  // 从大数据获取统计数据
  static async getStatistics(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/grpc/iot/statistics/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取历史测点数据
  static async getHistoryPointData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/WizIot/get-interval-runtime-value', payload)
    )
    return Callback(err, res)
  }
  // 阈值报警、气体检测报警列表
  static async findWarnRecordLists(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/alarm_record/time_section_alarms/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 阈值报警、气体检测报警统计
  static async findWarnRecordStatistic(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/alarm_record/alarm_statistic/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 月度报警次数（报警统计报表）
  static async findMonthAlarmTimes(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/labels_rely/query_pie_chart/${payload.year}/${payload.month}`
      )
    )
    return Callback(err, res)
  }
  // 月度报警清单(报警统计列表)
  static async findMonthAlarmLists(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/labels_rely/query_statistic_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 报警分布(报警统计列表)
  static async findMonthAlarmDistribution(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/alarm/labels_rely/query_hist_chart?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 每日报警分布(报警统计列表)
  static async findMonthAlarmEveryDayDistribution(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/alarm/labels_rely/query_line_chart/${payload.year}/${payload.month}`
      )
    )
    return Callback(err, res)
  }
  // 报警统计报表导出
  static async exportAlarmStatisticReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/alarm/labels_rely/charts_export?${qs.stringify(payload.query)}`,
        payload.data
      )
    )
    return Callback(err, res)
  }
}
